<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="charts-section">
	@if (authorizationService.canSee(grants.energyConsumptionTotalEnergyConsumption)) {
		@let totalEnergyConsumption = totalEnergyConsumption$ | async;

		<div class="energy">
			<globalictcc-kpi
				label="Total Energy Consumption"
				[value]="totalEnergyConsumption?.data?.value"
				[unit]="totalEnergyConsumption?.data?.unit"
			/>
		</div>
	}

	@if (authorizationService.canSee(grants.energyConsumptionMyRunningApps)) {
		@let appsEnergyConsumption = appsEnergyConsumption$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#appsEnergyConsumptionChart
				chartType="line"
				[data]="appsEnergyConsumption?.data?.chart"
				[isLoading]="appsEnergyConsumption?.isLoading ?? true"
				[hasError]="
					appsEnergyConsumption?.hasError || appsEnergyConsumption?.data?.hasError
				"
				[isLegendVisible]="true"
				(handleChartRefresh)="onAppsEnergyConsumptionChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							appsEnergyConsumptionChart.instance,
							'software_energy_consumption'
						)
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.energyConsumptionTop10Apps)) {
		@let worst10Apps = worst10Apps$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#worst10AppsChart
				chartType="barY"
				[data]="worst10Apps?.data?.chart"
				[isLoading]="worst10Apps?.isLoading ?? true"
				[hasError]="worst10Apps?.hasError || worst10Apps?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10AppsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(worst10AppsChart.instance, 'software_worst_10_apps_energy')
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.energyConsumptionTop10Layers)) {
		@let worst10Layers = worst10Layers$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#worst10LayersChart
				chartType="barY"
				[data]="worst10Layers?.data?.chart"
				[isLoading]="worst10Layers?.isLoading ?? true"
				[hasError]="worst10Layers?.hasError || worst10Layers?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10LayersChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							worst10LayersChart.instance,
							'software_worst_10_layers_energy'
						)
					"
				/>
			</div>
		</div>
	}
</div>
